import { Calendar } from "assets/icons";
import { ResetAction } from "components/actions";
import {
  DropdownSetting,
  HideableSetting,
  InformationSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { CalendarState, CalendarWidget } from "./CalendarWidget";
import { CalendarItemData } from "./interfaces";

export const DefaultEvent: CalendarItemData = {
  id: "default",
  event: "Jane's Birthday",
  image: "🎂",
};

export const InteractiveCalendarWidget: WidgetType<CalendarState> = {
  name: "Calendar",
  component: CalendarWidget,
  icon: Calendar,
  showOnToolbar: true,
  sizing: {
    minWidth: 300,
    minHeight: 350,
    minAspectRatio: 0.85,
    maxAspectRatio: 0.85,
  },
  defaultState: {
    selectedDateString: new Date().toDateString(),
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  },
  defaultSize: {
    aspectRatio: 0.85,
    widthPercentage: 20,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Choose calendar information",
      },
    },
    format: {
      editor: DropdownSetting,
      info: {
        name: "Date Format",
        options: [
          "24/04/2023 (DD/MM/YYYY)",
          "04/24/2023 (MM/DD/YYYY)",
          "24 Apr 2023",
          "24 April 2023",
          "Tuesday, 24 April 2023",
          "Tuesday, 24th April 2023",
        ],
      },
      defaultValue: "Tuesday, 24th April 2023",
    },
    start: {
      editor: HideableSetting,
      info: {
        editor: DropdownSetting,
        editorInfo: {
          name: "Week Starts on",
          options: ["Monday", "Sunday"],
        },
        watchSetting: "view",
        watchSettingValue: "Day",
      },
      defaultValue: "Monday",
    },
    prevDays: {
      editor: HideableSetting,
      info: {
        editor: ToggleSetting,
        editorInfo: {
          label: "Colour Previous Days",
        },
        watchSetting: "view",
        watchSettingValue: "Day",
      },
      defaultValue: true,
    },
    view: {
      editor: DropdownSetting,
      info: {
        name: "View",
        options: ["Month", "Day"],
      },
      defaultValue: "Month",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.calendar,
        widgetDisplayName: "Calendar",
      },
    },
  },
  quickActions: {
    reset: ResetAction,
  },
};
